var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 201,
    viewBox: "0 0 201 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8123_27470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.5276 37.1553C86.2909 36.4148 89.0621 35.8984 91.8226 35.5941L89.7151 27.7286C88.5136 23.2457 83.8896 20.5761 79.407 21.7772C74.9244 22.9783 72.2545 27.6023 73.4557 32.0852L75.5632 39.9508C78.1057 38.8338 80.7643 37.8957 83.5276 37.1553Z",
    fill: "#FCAC62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.11 136.513L173.372 133.76C172.846 131.795 171.143 130.342 169.033 130.057C160.706 128.932 153.92 122.961 151.746 114.845L142.075 78.7548C135.541 54.3694 110.386 39.8465 86.0014 46.3805C61.616 52.9145 47.0928 78.0695 53.6267 102.455L63.297 138.545C65.4718 146.661 62.5807 155.225 55.9315 160.363C54.2473 161.664 53.4993 163.774 54.0256 165.738L54.7633 168.491C55.513 171.289 58.3987 172.955 61.1964 172.206L101.29 161.463L130.303 153.689L170.396 142.946C173.193 142.196 174.859 139.31 174.11 136.513Z",
    fill: "#FCAC62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.048 171.98C110.51 177.435 116.138 180.685 121.593 179.223C127.049 177.761 130.298 172.133 128.836 166.678L128.159 164.15L108.371 169.452L109.048 171.98Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8123_27470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 163,
    height: 163,
    fill: "white",
    transform: "translate(0.683594 42.8708) rotate(-15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.8544ccee1c5bcff7026caf3f9749fdc3.svg";
export { ForwardRef as ReactComponent };